import {
  fetchNewsletterData,
  fetchNewslettersData,
} from "./actions/fetchActions";
import {
  newslettersReducer,
  newsletterReducer,
  createNewsletterReducer,
  updateNewsletterReducer,
  deleteNewsletterReducer,
} from "./reducers/fetchReducers";

const newsletterReducers = {
  newslettersGlobalStore: newslettersReducer,
  newsletterGlobalStore: newsletterReducer,
  createNewsletterGlobalStore: createNewsletterReducer,
  updateNewsletterGlobalStore: updateNewsletterReducer,
  deleteNewsletterGlobalStore: deleteNewsletterReducer,
};

export { fetchNewsletterData, fetchNewslettersData, newsletterReducers };
